import Image from "next/image";
import { useRouter } from "next/router";
import React, { useState } from "react";

const SearchBar = () => {
  const router = useRouter();
  const [search, setSearch] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    if (search.trim() !== "") {
      router.push(`/blog-kesfet?search=${search}`);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex items-center justify-between py-3 px-4 rounded-full border border-[#D9D9D9]"
    >
      <input
        type="text"
        name="search"
        onChange={(e) => setSearch(e.target.value)}
        className="placeholder:text-[#586474] text-[#586474] opacity-80 text-xs outline-none"
        placeholder="Blog Yazısı Ara"
      />
      <button type="submit">
        <Image
          src="/icons/blogSearch.svg"
          width={16}
          height={16}
          alt="Search"
        />
      </button>
    </form>
  );
};

export default SearchBar;
